import React, { useState, useEffect } from 'react';
import { $BillingAccountCreate } from '../../services/V2/gozer';
import { BillingAccountsVService as BillingAccountsV2Service } from '../../services/V2/gozer';
import { handleError } from '../shared/Functions';
import { AddModal } from '../shared/AddModal';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';
import { authProvider } from '../../services/Security';
import { DistrictsVService } from '../../services/V2/padre';
import { CustomTable } from '../shared/CustomTable';

export const BillingAccounts = () => {
    const [district, setDistrict] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [canCreateBillingAccount, setCanCreateBillingAccount] = useState<boolean>(false);
    const [filters, setFilters] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>();
    const [token, setToken] = useState<any>();

    window.addEventListener('message', event => {
        var message = JSON.stringify({
            hideSearch: false
        });
        window.parent.postMessage(message, '*');
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setFormData(data)
        setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (!formData) return;
        let filterArray: any[] = [];
        if (formData.districtId) filterArray.push({ property: "DistrictId", value: formData.districtId })
        if (formData.accountNumber) filterArray.push({ property: "AccountNumber", value: formData.accountNumber })
        if (formData.firstName) filterArray.push({ property: "Customer.FirstName", value: formData.firstName })
        if (formData.lastName) filterArray.push({ property: "Customer.LastName", value: formData.lastName })
        if (formData.email) filterArray.push({ property: "Customer.Email", value: formData.email })
        if (formData.status) filterArray.push({ property: "Status", value: formData.status })
        if (formData.street) filterArray.push({ property: "Customer.Street", value: formData.street })
        if (formData.city) filterArray.push({ property: "Customer.City", value: formData.city })
        if (formData.state) filterArray.push({ property: "Customer.State", value: formData.state })
        if (formData.zip) filterArray.push({ property: "Customer.Zip", value: formData.zip })
        if (formData.isActive != null) filterArray.push({ property: "IsActive", value: formData.isActive })
        if (formData.paperBilling != null) filterArray.push({ property: "Enrollment.Paperbill", value: formData.paperBilling })
        if (formData.disallowCC != null) filterArray.push({ property: "DisallowCCPayments", value: formData.disallowCC })
        if (formData.disallowACH != null) filterArray.push({ property: "DisallowACHPayments", value: formData.disallowACH })
        setFilters(filterArray)
    }, [formData])

    // useEffect(() => {
    //     if(resetQR && billingAccounts.length > 0){
    //         Promise.all(
    //             billingAccounts.map(x => InstaPayVService.instaPayVGetQrCode(x.id))
    //         ).then((qrCodes) => {
    //             var fullAccounts = billingAccounts.map((x, index) => {
    //                 return {
    //                     ...x,
    //                     qrCode: qrCodes[index]
    //                 }
    //             })
    //             setBillingAccounts(fullAccounts)
    //             setResetQR(false)
    //         }).catch(err => err.message !=="Not Found" && console.log(err))
    //     }
    // }, [billingAccounts])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!token || !formData) return;
        DistrictsVService.districtsVGetById(formData.districtId ?? "")
            .then(x => setDistrict(x))
            .catch(x => handleError(x))

        let perms = authProvider.getPermissions();
        setCanCreateBillingAccount(perms.some((perm: string) => perm === "CreateBillingAccounts"));
    }, [token, formData])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            {showAdd &&
                <AddModal
                    setShow={setShowAdd}
                    show={showAdd}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={BillingAccountsV2Service.billingAccountsVCreate}
                    keys={$BillingAccountCreate.properties}
                    modelName="Billing Account"
                    parentId={null}
                    parentsParentId={null}
                    parent={district}
                    parentValues={["districtId"]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            <CustomTable
                title=""
                columns={[
                    { title: 'District', field: 'districtId', editable: 'never', render: rowData => rowData?.districtinfo?.name },
                    { title: 'Account Number', field: 'accountNumber', editable: 'never' },
                    { title: 'First Name', field: 'customer.firstName', editable: 'never', render: (rowData: any) => rowData?.customer?.firstName },
                    { title: 'Last Name', field: 'customer.lastName', editable: 'never', render: (rowData: any) => rowData?.customer?.lastName },
                    { title: 'Email', field: 'customer.email', editable: 'never', render: (rowData: any) => rowData?.customer?.email },
                    { title: 'Status', field: 'status', editable: 'never' },
                    { title: 'Active', field: 'isActive', type: 'boolean', editable: 'never' },
                    { title: 'Paper Billing', field: 'enrollment.paperBill', type: 'boolean', editable: 'never', render: rowData => rowData?.enrollment?.paperBill ? <CheckIcon /> : <RemoveIcon /> },
                    { title: 'Disallow ACH Payments', field: 'disallowACHPayments', type: 'boolean', editable: 'never' },
                    { title: 'Disallow CC Payments', field: 'disallowCCPayments', type: 'boolean', editable: 'never' },
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        if (!formData?.districtId) resolve({
                            data: [],
                            page: query.page,
                            totalCount: 0
                        })
                        else
                            BillingAccountsV2Service.billingAccountsVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "AccountNumber",
                                orderByDesc: query.orderDirection === "desc",
                                filters: filters
                            }).then((x: any) => {
                                setLoading(false)
                                resolve({
                                    data: x.items ?? [],
                                    page: query.page,
                                    totalCount: x.numberOfItems ?? 0
                                })
                            }).catch(x => {
                                reject(x)
                            })
                    })
                }}
                actions={[
                    {
                        icon: () => <AddIcon />,
                        tooltip: "Add Billing Account",
                        isFreeAction: true,
                        onClick: (event, row) => setShowAdd(true),
                        disabled: !canCreateBillingAccount
                    }
                ]}
                refresh={loading} setRefresh={setLoading} dataSet={null} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null}
            />
        </React.Fragment>
    );
}